export default {
  //SubMenu
  clientsList: "Dossiers clients",
  collaborators: "Collaborateurs",
  myDashboard: "Mon Tableau de bord",
  collaboratorSpace: "Espace collaborateur",
  myBalanceSheet: "Mon Bilan",
  dashboardsModels: "Modèles Dashboards",
  slidesModels: "Modèles Slides",
  presentation: "Présentation",
  //Headers
  slidesList: "Liste des slides",
  collaboratorList: "Liste des collaborateurs",
  templatesDashboard: "MODÈLES DASHBOARD",
  //Subheaders
  clientsListSubHeader: "visualiser et gérer vos dossier clients",
  slidesListSubHeader: "visualiser et gérer vos slides",
  collaboratorListSubHeader: "Retrouvez tous les collaborateurs.",
  templatesDashboardSubHeader: "visualiser et gérer vos dashboards",
  balanceSheetSubHeader: "VUE DETAILLÉ SUR LA SANTÉ FINANCIÈRE",

  //Actions
  add: "Ajouter",
  use: "utiliser",
  post: "poster",
  send: "Envoyer",
  read: "lire",
  edit: "modifier",
  exit: "Quitter",
  save: "Enregistrer",
  hide: "Cacher",
  play: "Lire",
  apply: "Appliquer",
  cancel: "Annuler",
  import: "Importer",
  delete: "Supprimer",
  update: "Modifier",
  return: "Retour",
  logout: "Se déconnecter",
  search: "Recherche",
  sortBy: "Trier par",
  goBack: "Retour",
  prepare: "Préparer",
  seeAll: "Voir tous",
  validate: "Valider",
  associate: "associer",
  duplicate: "dupliquer",
  explore: "Explorer",
  selectAll: "selectionner tous",
  deselectAll: "Tout déselectionner",
  signIn: "Connexion / Inscription",
  generate: "Générer",
  regenerate: "Régénérer",
  showMore: "Lire plus",
  addToCalendar: "Ajouter au calendrier",
  //Label
  to: "à",
  the: "le",
  year: "Année",
  client: "Client",
  next: "Suivant",
  previous: "Précédent",
  filter: "Filtre",
  ratiosOf: "Ratios de",
  admin: "Administrateur",
  error: "Erreur",
  rendezVous: "Rendez-vous",
  caution: "Avertissement",
  balanceSheetOf: "Bilan de",
  typeOfEnterprise: "Type d'entreprise",
  juridicalForm: "Forme juridique",
  diaporama: "diaporama",
  unknown: "Inconnu",
  closingDate: "Date de clôture",
  duration: "Durée",
  startDate: "Date de début",
  endDate: "Date de fin",
  dateRange: "plage de dates",
  createdAt: "Crée le",
  updatedAt: "Modifié le",
  increaseOf: "hausse de",
  decreaseOf: "baisse de",
  inferior: "inférieur",
  superior: "supérieur",
  average: "dans la moyenne",
  settings: "Paramètres",
  communities: "Communautés",
  TAMTAMApplications: "Applications TAMTAM",
  Event: "Événement",
  Survey: "Enquête",
  profile: "Profil",
  preview: "Aperçu",
  title: "Titre",
  content: "Contenu",
  visibility: "visibilité",
  me: "Vous",
  indicator: "Indicateur",
  indicators: "indicateurs",
  nbrOfYears: "Nombre D'années",
  maxValue: "la Valeur max",
  minValue: "la Valeur min",
  annexeCategory: "Catégorie annexe",
  annexeYear: "Année d'annexe",
  fileName: "Nom du fichier",
  category: "Catégorie",
  importedAt: "Importé le",
  action: "Action",
  role: "Rôle",
  roles: "Rôles",
  recipients: "destinataires",
  recipient: "destinataire",
  categories: "catégories",
  allCategories: "Tous les catégories",
  all: "Tout",
  today: "Aujourd'hui",
  yesterday: "Hier",
  otherday: "Avant-hier",
  week: "la semaine",
  comments: "commentaire(s)",
  hidden: "Cachée",
  visible: "Apparente",
  certified: "Certifiée",
  main: "Principale",
  configuration: "Configuration",
  authorizations: "autorisations",
  newUser: "Nouveau utilisateur",
  users: "Utilisateurs",
  user: "Utilisateur",
  editor: "Éditeur",
  total: "Total",
  and: "et",
  as: "en tant que",
  sentTo: "envoyé à",
  justSent: "Envoyé à l'instant",
  resendAgain: "Envoyer à nouveau",
  preferences: "préférences",
  recentActivities: "activitées récentes",
  clientFolders: "Dossiers clients",
  configuredFolders: "Dossiers Configurés",
  noAnnexesFolders: "Dossiers Sans Annexes",
  noConfiguredFolders: "Dossiers Non Configurés",
  noActivities: "Aucune activitée",
  noOptions: "aucune option",
  relizedDuration: "Temps réalisé",
  traitMyFolders: "Gérer mes dossiers",
  clientIndicator: "Indicateur client",
  exercise: "Exercice",
  files: "Documents",
  home: "Accueil",
  none: "aucun",
  mutation: "mutation",
  financial: "finance",
  treasury: "Trésorerie",
  annexes: "Annexes",
  status: "statut",
  view: "aperçu",
  lastImport: "Dernier import",
  folder: "Dossier",
  extraSlideDescription:
    "Slides contenant des remarques que vous pouvez saisir, personnaliser et ajouter à la présentation.",
  remerciementDescription:
    'Slide contenant un mot de remerciement, "Merci de votre attention", un avatar du gestionnaire avec son prénom, nom, adresse email et numéro mobile.',
  questionsDescription:
    "Slide contenant une demande si le client a des questions, “Vous avez des questions?”.",
  finalDateValidationLink: "Valide jusqu’au",
  periodValidationLink: "Durée de validité du lien :",
  monday: "Lundi",
  tuesday: "Mardi",
  wednesday: "Mercredi",
  thursday: "Jeudi",
  friday: "Vendredi",
  saturday: "Samedi",
  sunday: "Dimanche",
  myFolders: "Mes Dossiers",
  myPresentations: "Mes présentations",
  by: "Par",
  private: "Privé",
  public: "Public",
  duplicated: "Dupliqué",
  original: "Original",
  share: "Partagé",
  standard: "Standard",
  created: "Crées",
  toUse: "À utiliser",
  frozen: "Figé",
  slide: "Slide(s)",
  sharedWithCommunity: "Partagé Avec La Communauté",
  yes: "Oui",
  no: "Non",
  new: "Nouveau",
  editableTemplate: "Modèle modifiable",
  //Titles
  recordVocal: "Enregistrer un commentaire vocal",
  library: "Bibliothèque",
  myTemplates: "mes modèles",
  slideView: "Aperçu du slide",
  createSlideTemplate: "créer modèle slide",
  createDashboardTemplate: "créer modèle dashboard",
  noLegalForms: "Pas de formes juridiques",
  presentations: "Présentations",
  clientType: "Client Type (CRM)",
  clientGroup: "Client Group (CRM)",
  inSomeFigures: "En Quelque Chiffres",
  affectedModel: "Modèle affécté",
  clientForm: "Fiche Client",
  manageAssociations: "Gérer les associations",
  managerSpace: "Espace Manager",
  manageExplanation: "Gérer les explications",
  manageCategories: "Gérer les catégories",
  addExplanation: "Ajouter une explication",
  addExplanations: "Ajouter des explications",
  addRecipients: "Ajouter des destinataires",
  addEmailTemplates: "Ajouter des models-mail",
  typeExplanations: "Tapez votre explications (3 langues disponible)",
  associationLegalForm: "Association Dashboard / Forme Legale",
  dashboardcreated: "Modèles Dashboards crées",
  dashboardstandard: "Modèles Dashboards standards",
  associateClientTitle: "Associer les clients au tableau de bord principal",
  companyNaturalPerson: "Entreprise personne physique",
  companyLegalPerson: "Entreprise personne morale",
  profitability: "Rentabilité",
  solvency: "Solvabilité",
  liquidity: "Liquidité",
  balanceSheet: "Bilan",
  slidePosition: "Position du slide",
  configureOrganization: "Configuration de l'organization",
  exercisesConfiguration: "Configuration des exercices",
  dashboard: "Tableau de bord",
  dashboardPrincipal: "dashboard principal",
  slideConfigurationPage: "Configuration du slide",
  slideTitle: "Titre du slide",
  slideBackgroundColor: "Couleur de fond",
  slideComponentColor: "Couleur des composants",
  slideLayoutTitle: "Changer Layout",
  componentsList: "LISTE DES COMPOSANTS",
  componentConfig: "Configuration du composant",
  createdSlides: "Slides crées",
  standardSlides: "Slides standards",
  allSlides: "Tous les slides",
  titleDuplicateSlide: "dupliquer le slide",
  titleAddSlide: "Ajouter le slide",
  titleUseSharedSlide: "Utiliser ce slide",
  titleAddDashboard: "Ajouter le dashboard",
  titleUseSharedDashboard: "Utiliser dashboard",
  addPresenter: "Ajouter un présentateur",
  importCustomerBalance: "Importer la balance du client",
  dashboardComposition: "Composition de Dashboard",
  slideComposition: "Composition de Slide",
  configuredExercises: "Exercices Configurés",
  importedBalances: "Balances Importées",
  updateCategory: "Modifier catégorie",
  createCategory: "Créer catégorie",
  addComment: "Ajouter un commentaire ...",
  moveSlideTemplate: "Déplacer le modèle slide",
  addSlideTemplate: "Inserer un modèle slide à la suite du slide actuel",
  switchSlideTemplate: "Remplacer le slide actuel par un modèle slide",
  chooseERP: "Choisir l'ERP",
  chooseModel: "Choisir le modèle",
  applyDashboardTemplate: "remplacer le modèle de présentation",
  undefinedVAT: "Le numéro de TVA n'est pas défini",
  titleDuplicateDashboard: "Dupliquer dashboard",
  attacherAnnexeCategorie: "attacher une annexe catégorie ",
  descriptionExercisesModel: "Description du modèle d'exercices",
  yearOfExercise: "Année exercice",
  MultipleYearsModel: "Modèle multiple",
  FiveYearsModel: "Modèle de 5 ans",
  TwoYearsModel: "Modèle de 2 ans",
  OneYearModel: "Modèle de 1 an",
  comparedModel: "Modèle exercices comparés",
  winbooksModel: "Modèle de 1 an",
  importAnnexes: "Import d'annexes",
  importBalance: "Import de balance",
  importCustomerAnnexe: "Import des annexes du client",
  seeMore: "Voir plus",
  otherUser: "Autre(s) utilisateur(s)",
  chooseCategory: "Choix de catégorie",
  chooseYear: "Choix de l'exercice",
  selectCommunity: "choisissez votre communauté",
  categoriesList: "Liste des catégories",
  explanationsList: "liste des explications",
  HiddenAnnex: "Annexe cachée",
  VisibleAnnex: "Annexe apparente",
  extraSlides: "Extra Slides",
  annexState: "État annexé",
  newSlide: "Nouveau slide",
  approveThisTemplate: "approuver ce model",
  newDashboard: "Nouveau dashboard",
  useAModele: "Utiliser un modèle",
  ajouterExtraSlideTitle: "Ajouter un extra slide",
  editExtraSlideTitle: "Modifier l'extra slide",
  titleModalCategory: "Créer ou modifier les catégories",
  chooseExtraSLide: "Choisissez un Extra Slide",
  dashboardYear: "Dashboard de l'année",
  categoryList: "Liste des catégories",
  addExtaSLide: "Ajouter un Extra SLide",
  addExercise: "Ajouter exercice",
  removeExercise: "Retirer exercice",
  associateClient: "associer au dashboard",
  updateExplanation: "Modifier une explication",
  undefinedPresentationDate: "Date de présentation non définie",
  presentationDone: "Présentation effectuée",
  presentationNotPrepared: "Présentation non préparée",
  readyPresentation: "Présentation prête",
  preparedPresentation: "Présentation préparée",
  notPrepared: "non préparée",
  prepared: "préparée",
  presented: "presentée",
  synchronized: "Clients avec bilan synchronisé",
  presentedThe: "Présenté le",
  toPresenteThe: "à présenter le",
  frExplanation: "explication en Français",
  enExplanation: "explication en Anglais",
  nlExplanation: "explication en Néerlandais",
  processing: "Traitement en cours",
  frTitle: "Titre Français",
  enTitle: "Titre Anglais",
  nlTitle: "Titre Néerlandais",
  externalLinks: "Liens externes",
  notConfigured: "Non configuré",
  undefinedDate: "Date non définie",
  noAnnexes: "Sans annexes",
  withAnnexe: "Avec annexe",
  notCompleted: "Non complet",
  completed: "Complet",
  accountingRoles: "Rôles Accounting",
  organizationRoles: "Rôles organisation",
  dashboardPrivileges: "privilèges dashboard",
  associatePrivileges: "privilèges association",
  allowCreateDashboard: "Autoriser la création de dashboard",
  allowCreateSlide: "Autoriser la création d'un slide",
  allowUpdateDashboard: "Autoriser la modification des dashboards",
  allowUpdateSlide: "Autoriser la modification des slides",
  allowAccessDashboard: "Autoriser l'accès à la liste de dashboard",
  allowAccessCollaborator: "Autoriser l'accès à la liste des collaborateurs",
  allowAccessParameters: "Autoriser l'accès à la liste des paramètes",
  allowAccessSlide: "Autoriser l'accès à la liste des slides",
  allowAssociateDashboards: "Autoriser l'association des dashboard",
  parameterPrivileges: "Privilèges des paramètres",
  companyDateCreation: "Date de création de la société",
  presentationPreparation: "Préparation de la présentation de l'année",
  preparationPresention: "Préparation de la présentation",
  creationDashboard: "Création de dashboard",
  creationSlide: "Création de slide",
  saveFinish: "Enregistrer & Terminer",
  makeVisible: "Rendre visible",
  addCategory: "Ajouter une catégorie",
  clientVisibility: "Visibilité client",
  organizationState: "état organisation",
  datePresentation: "Date de présentation ",
  linkGenered: "Lien généré",
  linkNotGenered: "Lien non généré",
  presentationLink: "Lien de Présentation",
  feedbackRequest: "Demande de feedback",
  sendRequest: "Envoyer la demande",
  sendLink: "Envoyer le link",
  sendAppointment: "Envoyer le Rendez-vous",
  addNew: "Ajouter un nouveau",
  sendToAddress: "Envoyer à l'adresse",
  refresh: "Appliquer filtre par default",
  presentationExtraSlide: "Extra slides de la présentation",
  slideRemerciement: "Slide de Remerciement",
  slideQuestions: "Slide de Questions",
  linkPresentation: "Lien partageable de la présentation",
  titleSharedDashboard: "Partager dashboard",
  titleSharedSlide: "Partager slide",
  titleVisibilitySlide: "Visibilité du slide",
  titleVisibilityDashboard: "Visibilité du dashboard",
  notifyNewDashboard: "Un nouveau dashboard ",
  notifyNewDashboards: " Nouveaux dashboards sont a votre disposition",
  notifyAtYourDisposal: " est a votre disposition ",
  notifyNewSlide: "Un nouveau slide ",
  notifyUsingUa:
    "Attention : Ce lien ne sera plus fonctionnel. Veuillez se connecter via ce lien: ",
  notifyNewSlides: " Nouveaux slides sont a votre disposition",
  notifyNewSharedDashboard: "Un nouveau dashboard partagé ",
  notifyNewSharedSlide: "Un nouveau slide partagé ",
  notifyNewSharedSlides: " Nouveaux slides partagés sont a votre disposition",
  notifyNewSharedDashboards:
    " Nouveaux dashboards partagés sont a votre disposition",
  notifyNewImportedBalance: "Une nouvelle balance est importée pour le client ",
  notifyNewImportedBalances:
    " Nouveaux balances importées sont a votre disposition",
  slideEditableInfos:
    "Ce slide sera partagé avec les autres fiduciaires avec le droit de l'utiliser telle qu'il est",
  dashboardEditableInfos:
    "Ce dashboard sera partagé avec les autres fiduciaires avec le droit de l'utiliser telle qu'il est",

  //Messages
  successfulAction: "Action réussie",
  toSumUp: "Pour resumer",
  affectedDashboard: "dashboard affecté",
  operationCompleted: "Action réalisée avec succès",
  errorOccured: "Une erreur est survenue, essayez plus tard.",
  searchByNameOrVATnumber: "Recherche par nom ou numéro de TVA",
  searchBySlideName: "Recherche par nom du slide ...",
  searchByDashboardName: "Recherche par nom du dashboard ...",
  searchByName: "Recherche par nom",
  wip: "En cours de developpement",
  notifUpdates: "Notifications de mises à jour",
  nothingToShow: "Aucunes notification n'est diponible",
  incorrectFile: "Le fichier importé est incompatible!",
  noPresentations: "Aucune présentation trouvée",
  pageNotFound: "Cette page n'a pas pu être trouvée!",
  nothingFound: "Oups, Aucun résultat ne correspond à votre recherche",
  justSentToRecipients:
    "Certains destinataires selectionnés vient de recevoir ce mail",
  moreExercicesRequired:
    "- Ce <b>modèle de balance</b> nécessite plus d'exercies configurés...",
  applyAuthorizationMessage:
    "Appliquer l'autorisation aux utilisateurs sélectionnés",
  selectedModeleDashboard: "Modèle de dashboard sélectionné :",
  availableModeleDashboard: "Modèles de dashboard disponibles :",
  deleteCommentsWarning: "Tous les commentaires liés vont être supprimés.",
  deleteHiddenSlidesWarning: "Tous les slides cachés vont être supprimés.",
  desableExtraSlidesWarning:
    "Les extra-slides vont être desactivés, dans la possibilité d'éditer.",
  oops: "Oups",
  notAvailable: "Non disponible",
  noResult: "Aucun résultat",
  typeCategoryTitle: "Tapez le titre de votre catégorie (3 langues disponible)",
  updateExercices: "la configuration des exercices est mise à jour",
  readyDashAssociate: "Dashboard prêt pour être associer aux clients",
  accessDenied: "Accès refusé",
  dashboardNotFound: "Dashboard Introuvable",
  organizationNotFound: "organization Introuvable",
  recipientsNotFound: "aucun destinataire trouvé! merci de les configurer",
  emailModelsNotFound: "Aucun template mail trouvée! merci de les configurer",
  goClientPage: "Vous pouvez revenir à la page de Liste des clients",
  noBalanceImported: "Pas de balance importée",
  chooseDashboardTemplates: "Choisir le model dashboard",
  deleteExtraSlideToo: "Ecraser les extra-slides aussi ",
  noBalanceImportedMessage:
    "Aucune balance n’a été importée à ce jour. Pour toute question sur votre dossier, nous vous remercions de contacter votre gestionnaire.",
  sendSuccess: "envoi réussi",
  mailSent: "Mail envoyé avec succès",
  importBalanceSuccess: "l'import de balance est effectué avec success",
  importAnnexeSuccess: "l'import d'annexe est effectué avec success",
  updateAssociationSuccess: "l'association est effectuée avec success",
  definePresentationDate: "Définir une date de présentation",
  selectPresentationDate: "Selectionner la date de présentation...",
  presentationPreparedQuestion: "Présentation préparée ?",
  presentationPresentedQuestion: "Présenté au client ?",
  presentationFreezedQuestion: "Figer la presentation ?",
  setPresentationState: "Marquer l’état de la présentation",
  slideSaved: "slide enregistrée avec succès",
  deleteComponentConfirm: "Voulez-vous supprimer ce composant ?",
  cancelConfirmContent: "Toute modification sera annulée.",
  cancelConfirm: "Voulez-vous annuler?",
  exitConfirm: "Voulez-vous quitter?",
  deleteConfirm: "Voulez-vous supprimer?",
  sharedConfirm: "Voulez-vous partager?",
  deleteConfirmContent: "Dashboard sera supprimée",
  deleteSlideConfirmContent: "Slide sera supprimée",
  sharedSlideConfirmContent: "Slide sera partagée",
  duplicatedSlideConfirmContent: "Slide sera dupliquée",
  saveSuccess: "Sauvegarde réussie",
  importSuccess: "Import réussie",
  removeSuccess: "La suppression est réussie",
  dashboardDeleted: "Dashboard Supprimée",
  deleteDashboardSuccess: "Dashboard supprimée avec succés",
  dashboardDuplicated: "dashboard dupliqué",
  duplicateDashboardSuccess: "Dashboard dupliqué avec success",
  slideDuplicated: "slide dupliqué",
  dashboardAdded: "Dashboard ajouté",
  slideAdded: "slide Ajouté",
  duplicateSlideSuccess: "slide dupliqué avec success",
  addSlideSuccess: "slide ajouté avec success",
  addDashboardSuccess: "Dashboard ajouté avec success",
  slideDeleted: "Slide Supprimée",
  slideDeletedSuccess: "Slide supprimée avec succés",
  slideSharedSuccess: "Slide partagée avec succés",
  slideShared: "Slide Partagée",
  successUpdated: "Mise à jour réussie",
  categoryUpdated: "Catégorie mise à jour",
  categoryAdded: "Catégorie ajoutée",
  categoryDeleted: "Catégorie supprimée",
  explanationAdded: "explication ajoutée",
  explanationDeleted: "explication supprimée",
  commentDeleted: "Commentaire supprimée",
  commentUpdated: "commentaire modifié avec success",
  commentNull: "commentaire vide",
  explanationUpdated: "explication modifié avec success",
  explanationSaved: "explication enregistrée avec succès",
  annexeDeleted: "Annexe supprimé",
  deleteConfirmation: "Confirmation de suppression",
  deleteExplanationContent:
    "Souhaitez-vous vraiment supprimer cette explication?",
  deleteCategoryContent: "Souhaitez-vous vraiment supprimer cette catégorie?",
  deleteCommentContent: "Souhaitez-vous vraiment supprimer ce commentaire?",
  deleteAnnexeContent: "Souhaitez-vous vraiment supprimer cet annexe?",
  categoriesStateUpdated: "État des catégories mis à jour",
  mainAnnexeUpdated: "Annexe principale mise à jour",
  hiddenAnnexeUpdated: "Visibilité Annexe mise à jour",
  certifiedAnnexeUpdated: "Certification Annexe mise à jour",
  addAnnexes: "Ajouter plusieurs annexes",
  importAnnexeSub:
    "Importer des annexes en indiquant leurs categories et années",
  updateSuccess: "mise à jour avec succès",
  deleteExtraSlide: "Extra Slide sera supprimée",
  extraSlideDeleted: "Extra Slide supprimé avec succès",
  accessRole: "votre profile ne vous permet pas d'acceder a cette option",
  gotLost: "Vous avez navigué si vite et vous êtes perdu...",
  specialAssociationMessage: "Ce modèle est associé directement à l’entreprise",
  createdAssociationMessage:
    "Ce modèle est associé à la forme légale de l’entreprise",
  defaultAssociationMessage: "Ce modèle est associé par défaut",
  noBalance: "Aucune balance n'est importée pour cette organisation.",
  importInProgress:
    "L'import de la balance est en cours. Veuillez patienter un instant ...",
  dragFile:
    "Faites glisser et déposer un fichier ici, <br> ou cliquez pour sélectionner le fichier à télécharger.",
  dragFiles:
    "Faites glisser et déposer les fichiers ici, <br> ou cliquez pour sélectionner les fichiers à télécharger.",
  confirmationUnFreezePresentationMessage:
    "<div><span>attention en enregistrant et terminant cette preparation vous risquer que:</span><ul><li>Tous les commentaires liés vont être supprimés.</li><li>Tous les slides cachés vont être supprimés.</li><li>Les extra-slides vont être desactivés, dans la possibilité d'éditer.</li></ul></div>",
  componentNotAvailable: "Composant non disponible",
  duplicateSlideContent: "voulez-vous dupliquer ce slide?",
  addSlideContent: "Voulez vous ajouter ce slide à mes modèles ?",
  useSharedSlideContent:
    "voulez vous utiliser ce slide ? (Attention le modèle choisi est non modifiable )",
  addDashboardContent: "voulez vous ajouter ce dashboard à mes modèles?",
  useSharedDashboardContent:
    "Voulez vous utiliser ce dashboard ? (Attention le modèle choisi est non modifiable )",
  duplicateDashboardContent: "voulez-vous dupliquer ce dashboard?",
  categoryCreated: "Catégorie crée",
  visibilityUpdated: "Visibilité mise à jour",
  confirmationDeleteCategoryMessage:
    "Voulez-vous supprimer la catégorie <br> il est possible d'être lié a des extra slides ?",
  confirmationDeleteCategoryTitle: "Confirmation de suppression",
  noConfiguredExercice:
    "Les exercices du bilan pas encore configurés pour cette organisation.",
  incompleteOperation:
    "Impossible de terminer l'opération, des données incorrectes ont été soumises",
  slideAlreadyUsedDeleteError:
    "Slide ne peut pas être supprimé, il est utilisé par une autre organisation",
  slideAlreadyUsed:
    "Slide ne peut pas être mis à jour, il est utilisé par une autre organisation",
  dashboardAlreadyUsedDeleteError:
    "Dashboard ne peut pas être supprimé, il est utilisé par une autre organisation",
  dashboardAlreadyUsed:
    "Dashboard ne peut pas être mis à jour, il est utilisé par une autre organisation",
  incompleteInfo:
    "impossible d'enregistrer le composant, vous devez indiquer toutes les informations requises",
  incompatibleModel: "Le fichier importé ne correspond pas au model choisis !",
  kluwerFiveYearsModelDescription:
    "Ce modèle comport 5 exercices importés en correspant par ordre les exercices en dessous et les exercices du fichier a importer",
  kluwerTwoYearsModelDescription:
    "Ce modèle comport 2 exercices importés en correspant par ordre les exercices en dessous et les exercices du fichier a importer",
  kluwerOneYearModelDescription:
    "Ce modèle import 1 seul exercice mentionné en dessous",
  kluwercomparedModelDescription:
    "Ce modèle permet d'importer 1 à 5 exercices. Sa particularité repose sur le fait qu'il est le seul modèle qui vous permet d'importer un exercice annuel composé de plus de 4 périodes (12 mois)",
  winbooksModelDescription:
    "Ce modèle import 1 seul exercice mentionné en dessous",
  multipleModelDescription: "Ce modèle import un ou plusieurs exercice ",
  applicationNotActivated:
    "L'application Accounting n'est pas Activée pour l'organisation actuelle.",
  applicationNotActivatedIndication:
    "Pour plus d'informations sur ce produit, merci de nous consulter.",
  about_us_content:
    "est une suite d'outils qui permet à une communauté de communiquer, partager, organiser ou  collaborer efficacement.  La plateforme est équipée de diverses applications assemblées selon les besoins par le client.  Grace  à nos outils mutualisés, nos clients disposent des dernières technologies sans devoir en assurer le développement au profit de leur core business.",
  annexeNotAvailable:
    "Cet annexe n'est pas disponible pour cette organization.",
  applicateDashboardTemplateMessage:
    "Les commentaires et les slides cachés seront écrasés en cas d'application d'un nouveau modèle dashboard!",
  actionsOnExplinations: "Ajouter, modifier ou supprimer vos explications",
  actionsOnCategories: "Ajoutez, activez ou désactivez vos catégories",
  listCommunity: "Liste des communautés membre",
  communityUnauthorised: "Cette communauté n’a pas d'accès à cette application",
  noRightsForOperations: "Vous n'avez pas les droits pour l'opération demandée",
  choiceModelEmail: "Choisissez un modèle d’email à envoyer au client",
  alertHistoryMessage:
    "Un ou plusieurs mails ont dejà étés envoyés pour cette presentation, scroller pour plus details :",
  msgEmptyField: "Veuillez saisir le titre du slide (au moins une langue).",
  dashboardSharedSuccess: "Dashboard partagée avec succés",
  dashboardShared: "Dashboard Partagée",
  sharedSlideContent: "Voulez-vous partager ce slide ?",
  sharedDashboardContent: "Voulez-vous partager ce dashboard ?",
  visibilitySlideContent: "Voulez-vous rendre ce slide privé ?",
  visibilityDashboardContent: "Voulez-vous rendre ce dashboard privé ?",
  slidePrivateSuccess: "Slide privé",
  dashboardPrivateSuccess: "Dashboard privé",

  // ENUM
  ACTIVATED: "ACTIVÉ",
  DEACTIVATED: "DÉSACTIVÉ",

  ADMIN: "Administrateur",
  USER: "Utilisateur",
  NONE: "Aucun",
  EDITOR: "Éditeur",
  LEGAL_REPRESENTATIVE: "Représentant légal",
  OFFICIAL: "Officiel",
  EXTERNAL: "Externe",
  MANAGER: "Manager",
  COLLABORATOR: "Collaborateur",
  SUPERVISOR: "Superviseur",

  READY: "PRÊT",
  CONFIGURED: "CONFIGURÉ",
  PENDING: "EN ATTENTE",
  NOT_CONFIGURED: "NON CONFIGURÉ",
  NO_ANNEXES: "SANS ANNEXE",

  gd: "Gestionnaire Dossier",
  ge: "Gestionnaire d'Encodage",
  es: "Superviseur d'Encodage",
  super: "Superviseur",
  scan: "Operateur Scan",

  white: "Blanc",
  bleu: "Bleu",

  Activated: "Activées",
  Disabled: "Désactivées",

  French: "Français",
  English: "Anglais",
  Dutch: "Néerlandais",

  Ready: "Prêt",
  configured: "Configué",
  Pending: "En attente",

  Synchronizing: "Dernière date de synchronisation",

  Confirm: "Oui, j'ai compris",

  UploadConfirm: "Confirmer l'import de balance",
  UploadConfirmContent:
    "Attention! Les balances exploitées par synchronisation seront perdues.",

  badPerformancesCollaborator1: "bad Performances Collaborator 1",
  badPerformancesCollaborator2: "bad Performances Collaborator 2",
  badPerformancesCollaborator3: "bad Performances Collaborator 3",
  badPerformancesCollaborator4: "bad Performances Collaborator 4",
  passablePerformancesCollaborator1: "passable Performances Collaborator 1",
  passablePerformancesCollaborator2: "passable Performances Collaborator 2",
  passablePerformancesCollaborator3: "passable Performances Collaborator 3",
  passablePerformancesCollaborator4: "passable Performances Collaborator 4",
  goodPerformancesCollaborator1: "good Performances Collaborator 1",
  goodPerformancesCollaborator2: "good Performances Collaborator 2",
  goodPerformancesCollaborator3: "good Performances Collaborator 3",
  goodPerformancesCollaborator4: "good Performances Collaborator 4",
  greatPerformancesCollaborator1: "great Performances Collaborator 1",
  greatPerformancesCollaborator2: "great Performances Collaborator 2",
  greatPerformancesCollaborator3: "great Performances Collaborator 3",
  greatPerformancesCollaborator4: "great Performances Collaborator 4",
  badPerformancesOrganization1: "bad Performances Organization 1",
  badPerformancesOrganization2: "bad Performances Organization 2",
  badPerformancesOrganization3: "bad Performances Organization 3",
  badPerformancesOrganization4: "bad Performances Organization 4",
  passablePerformancesOrganization1: "passable Performances Organization 1",
  passablePerformancesOrganization2: "passable Performances Organization 2",
  passablePerformancesOrganization3: "passable Performances Organization 3",
  passablePerformancesOrganization4: "passable Performances Organization 4",
  goodPerformancesOrganization1: "good Performances Organization 1",
  goodPerformancesOrganization2: "good Performances Organization 2",
  goodPerformancesOrganization3: "good Performances Organization 3",
  goodPerformancesOrganization4: "good Performances Organization 4",
  greatPerformancesOrganization1: "great Performances Organization 1",
  greatPerformancesOrganization2: "great Performances Organization 2",
  greatPerformancesOrganization3: "great Performances Organization 3",
  greatPerformancesOrganization4: "great Performances Organization 4",

  RequestSyncing: "Demander Synchronisation",
  RequestSyncingContent:
    "la demande de synchronisation est effectuée avec succès",
  Syncing: "En cours de synchronisation",
  WaitingSync: "En attente de synchronisation",
  fullScreen: "Plein écran"
};



// WEBPACK FOOTER //
// ./src/i18n/fr.js